/**
 * 物流图标
 */
const ShippingIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9987 4.7002L20.7936 10.4648V18.2998H3.19397V4.7002H14.9987Z"
        stroke="black"
        strokeWidth="2.4"
      />
      <rect x="4.4906" y="20" width="3" height="1" stroke="black" />
      <rect x="16.4906" y="20" width="3" height="1" fill="black" stroke="black" />
      <rect x="6.49695" y="8.5" width="6" height="1" fill="#BBBBBD" stroke="black" />
    </svg>
  )
}

export default ShippingIcon
